import { Markup } from 'interweave'
import React, { useRef } from 'react'

interface Props {
    innerHTML: { __html: string }
    className?: string
}


export const BareHtml = {
    p: (props: Props) => {
        const containerRef = useRef(null)

        return (
            <p ref={containerRef} className={props.className}>
                <Markup content={props.innerHTML.__html}/>
            </p>
        )
    },
    div: (props: Props) => {
        const containerRef = useRef(null)

        Array.from(document.getElementsByClassName('fr-emoticon')).map(
            (item) => {
                if(item?.attributes[1]?.value && !item?.attributes[1]?.value.includes('repeat')) {
                    item.attributes[1].value =
                        item.attributes[1].value +
                        ' background-repeat: no-repeat; display: inline-block; width: 20px; margin: 2px;'
                }
            }
        )

        return (
            <div ref={containerRef} className={props.className}>
                <div dangerouslySetInnerHTML={{__html: props.innerHTML.__html}}/>
            </div>
        )
    },
}
